/**
 * Segments Page
 * 
 * Customer segmentation management (basic MVP)
 */

import { Page, Card, BlockStack, Text, Banner } from "@shopify/polaris";

function SegmentsPage() {
  return (
    <Page
      title="Customer Segments"
      subtitle="Create and manage customer segments for targeted campaigns"
    >
      <BlockStack gap="400">
        <Banner tone="info">
          <BlockStack gap="200">
            <Text as="p" fontWeight="semibold">
              Coming in Phase 9 - Advanced Features
            </Text>
            <Text as="p">
              Customer segmentation will allow you to create targeted campaigns based on:
            </Text>
            <ul style={{ marginLeft: '1.5rem' }}>
              <li>Customer tags</li>
              <li>Purchase history</li>
              <li>Total spent</li>
              <li>Order count</li>
              <li>Custom attributes</li>
            </ul>
          </BlockStack>
        </Banner>

        <Card>
          <BlockStack gap="400">
            <Text as="h2" variant="headingMd">
              Current Targeting Options
            </Text>
            <Text as="p">
              You can already target campaigns using the <strong>Targeting Rules</strong> builder in the Campaign editor. This provides:
            </Text>
            <ul style={{ marginLeft: '1.5rem' }}>
              <li><strong>Customer conditions:</strong> Tags, email, orders, spend</li>
              <li><strong>Cart conditions:</strong> Total value, item count, specific products</li>
              <li><strong>Product conditions:</strong> Collections, tags, price</li>
              <li><strong>Geo conditions:</strong> Country, region, city</li>
              <li><strong>Logical operators:</strong> AND, OR, NOT combinations</li>
            </ul>
          </BlockStack>
        </Card>

        <Card>
          <BlockStack gap="400">
            <Text as="h2" variant="headingMd">
              Quick Start Guide
            </Text>
            <BlockStack gap="300">
              <div>
                <Text as="p" fontWeight="semibold">
                  1. Go to Campaigns → Create/Edit Campaign
                </Text>
                <Text as="p" tone="subdued">
                  Navigate to the campaign you want to target
                </Text>
              </div>
              <div>
                <Text as="p" fontWeight="semibold">
                  2. Scroll to "Targeting Rules" section
                </Text>
                <Text as="p" tone="subdued">
                  This is where you configure who sees your campaign
                </Text>
              </div>
              <div>
                <Text as="p" fontWeight="semibold">
                  3. Add conditions using the visual builder
                </Text>
                <Text as="p" tone="subdued">
                  Combine multiple conditions with AND/OR logic
                </Text>
              </div>
              <div>
                <Text as="p" fontWeight="semibold">
                  4. Test with Preview
                </Text>
                <Text as="p" tone="subdued">
                  Use the preview panel to validate your targeting logic
                </Text>
              </div>
            </BlockStack>
          </BlockStack>
        </Card>
      </BlockStack>
    </Page>
  );
}

export default SegmentsPage;
